import React, { useEffect } from 'react';
import { i18nIntl } from '../../lib/ep';
import { injectIntl } from 'react-intl';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import TimeCounterSimple from '../builder/TimeCounterSimple';
import ButtonCollection from '../builder/ButtonCollection';
import PromotionExpired from '../users/PromotionExpired';

function b64DecodeUnicode(str) {
	if (str == undefined) return str;
	return decodeURIComponent(atob(str).split('').map(function(c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
}

const Wrapper = (props) => {
	const icon = props?.icon ?? 'knk-zipped';
	const link = props?.link ?? false;
	const link_type = props?.link_type ?? 'button';
	const description = props?.description ?? false;
	const subdescription = props?.subdescription ?? false;
	const additional = props?.additional ?? false;
	const error_type = props?.error_type ?? 'generic';

	const seconds = props?.seconds ?? false;

	return (
		<div class={`flex_cols is_${error_type}`}>
			<div class="flex_col col_1 iconed_media">
				<div class="main_media_flex">
					<span class={`icon ${icon}`} />
				</div>
			</div>

			<div class="flex_col col_2 mod_align_center not_in_top">
				<article
					class="gui_text_block"
					style={{
						'--text-text-align':'center',
						'--h1-text-align':'var(--text-text-align)',
						'--p-text-align':'var(--text-text-align)',
					}}
				>
					<Title>{props.title}</Title>

					<Subtitle>{props.subtitle}</Subtitle>

					{(seconds !== false) && (
						<div class="dates_mod registration_info">
							<TimeCounterSimple
								seconds={seconds}
								onFinish={() => props.onFinish()}
								_class={{other:'value gui_main_text_color_on_bg'}}
							/>
						</div>
					)}
				</article>

				{(description) && (
					<p dangerouslySetInnerHTML={{__html:description}} />
				)}

				{(subdescription) && (
					<Subtitle>{subdescription}</Subtitle>
				)}

				{(additional) && (
					<div class="gui_not_in_top">{additional}</div>
				)}

				{(link_type == 'button') && (
					<ButtonCTA {...link} />
				)}

				{(link_type == 'link') && (
					<LinkCTA {...link} />
				)}
			</div>
		</div>
	)
};

const Title = (props) => {
	if(props.children == undefined) return null;

	return (
		<h1 dangerouslySetInnerHTML={{__html:props.children}} />
	)
};

const Subtitle = (props) => {
	if(props.children == undefined) return null;

	return (
		<p dangerouslySetInnerHTML={{__html:props.children}} />
	)
};

const ButtonCTA = ({ children, ...props }) => {
	if(children == undefined) return null;

	return (
		<article class="template_submodule mod_align_center call_to_action_flex enter_flexwrap">
			<div class="enter flex_button gui_big_button register_flex">
				<ActionButton
					_fullclass=""
					{...props}
				>{children}</ActionButton>
			</div>
		</article>
	)
}

const LinkCTA = ({ children, ...props }) => {
	if(children == undefined) return null;

	return (
		<article class="template_submodule mod_align_center call_to_action_flex gui_not_in_top_small">
			<ActionLink
				{...props}
			>{children}</ActionLink>
		</article>
	)
}

const NotAllowed = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const error_type = props?.error_type ?? 'not_available';
	const error_subtype = props?.error_subtype ?? false;
	const promotion = props?.promotion?.Promotion ?? false;
	const remaining_participations = props?.remaining_participations ?? false;
	const is_visitor = props?.visitor ?? false;

	let label_my_participations = "View my participations";
	let link_my_participations = `/users/my_participation/${promotion.id}`;
	if(is_visitor){
		label_my_participations = "Back";
		link_my_participations = `/login/${promotion.id}`;
	}

	const navigateToPromo = () => {
		document.location.href = `/p/${promotion.id}`;
	};

	useEffect(() => {
		if(error_type !== false && error_type != '') {
			if(typeof window.onNotAllowed == 'function') {
				window.onNotAllowed(error_type);
			}
		}
	}, []);

	if(error_type == 'not_verified') {
		return (
			<Wrapper
				icon='knk-accept-user'
				title={i18n("Only verified users can enter this promotion")}
				subtitle={i18n("A user is considered as verified by Facebook if he took any of these actions: Registers for mobile, confirms his account via SMS or enters a valid credit card number.")}
				error_type={error_type}
				link={{
					_target:'_blank',
					_href:'https://www.facebook.com/help/?page=116296378454689',
					children:"More information",
				}}
			/>
		)
	}

	if(error_type == 'hash') {
		return (
			<Wrapper
				title={i18n("You cannot enter this promotion")}
				subtitle={`${i18n("You have reached the maximum of registrations for this computer.")} ${i18n("Please, try again in our next promotion. Thanks.")}`}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'no_promotions') {
		return (
			<Wrapper
				title={i18n("Currently there are no active promotions.")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'expired') {
		if(props.promotion != undefined) {
			return (
				<PromotionExpired
					promotion={props.promotion}
				/>
			)
		}

		return (
			<Wrapper
				title={i18n("This promotion has expired")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'ip_delay') {
		return (
			<Wrapper
				icon='knk-timecounter'
				title={i18n("You cannot enter this promotion right now")}
				subtitle={i18n("Somebody has entered this promotion from the same IP as you a few moments ago. Please, try it again later.")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'filter_by_country') {
		const countries = props?.countries || {};
		const accessible_countries = promotion.countries.split(",");
		let countries_list_arr = [];
		if(accessible_countries.length > 0) {
			accessible_countries.map((country) => {
				if(country == "") return;
				countries_list_arr.push((countries[country] != undefined) ? countries[country] : country);
			});
		}

		let countries_list;
		if(countries_list_arr.length > 1) {
			let countries_list_visible = [];
			countries_list_arr.map((country, c) => {
				if(c >= countries_list_arr.length - 1) return;
				countries_list_visible.push(`<strong>${country}</strong>`);
			});
			countries_list = countries_list_visible.join(", ");
			countries_list += `${i18n(" and ")}<strong>${countries_list_arr[countries_list_arr.length - 1]}</strong>`;
		} else {
			countries_list = `<strong>${countries_list_arr[0]}</strong>`;
		}

		return (
			<Wrapper
				icon='knk-geographic-area'
				title={i18n("You are not allowed to see this promotion")}
				subtitle={i18n("Only available for connection from %s.").replace("%s", countries_list)}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'extra_verification') {
		return (
			<Wrapper
				icon='knk-accept-user'
				title={i18n("You need extra verification to continue")}
				error_type={error_type}
				link={{
					_href:`https://wl.easypromosapp.com/p/12921?ep1=${promotion.id}`,
					children:"Verify my identity",
				}}
			/>
		)
	}

	if(error_type == 'unavailable') {
		if(error_subtype == 'nlt') {
			return (
				<Wrapper
					icon='knk-reject-user'
					title={promotion?.config?.block_blacklist_text ?? `${i18n("Sorry!")}<br />${i18n("We could not sign you in")}`}
					subtitle={i18n("Your device's security settings do not allow you to sign in.")}
					subdescription={i18n("Press the following button to reload the promotion outside the web, and try signing up again.")}
					error_type={error_type}
					additional={<>
						<ButtonCollection
							_class={{ other:'flex_button gui_big_button' }}
						>
							<ActionButton
								_fullclass=''
								_href={`${props.public_url}p/${promotion.id}`}
								_target="_parent"
							>Retry</ActionButton>
						</ButtonCollection>
					</>}
				/>
			)
		}

		return (
			<Wrapper
				icon='knk-reject-user'
				title={promotion?.config?.block_blacklist_text ?? i18n("Access blocked")}
				subtitle={i18n("Sorry, you can't participate")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'invalid_email') {
		return (
			<Wrapper
				icon='knk-email'
				title={i18n("The submitted email is not valid")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'no_valid') {
		return (
			<Wrapper
				title={i18n("Not valid entry")}
				error_type={error_type}
			/>
		)
	}
	
	if(error_type == 'no_stage_available') {
		return (
			<Wrapper
				title={i18n("There is no participation stage available")}
				error_type={error_type}
				link={{
					_href:`/p/${promotion.id}`,
					children:"Go back",
				}}
				link_type='link'
			/>
		)
	}

	if(error_type == 'not_published') {
		return (
			<Wrapper
				title={i18n("The promotion is not published")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'qr_code') {
		return (
			<Wrapper
				title={i18n("This QR code is expired")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'max_entries') {
		return (
			<Wrapper
				icon='knk-entries'
				title={i18n("Maximum number of entries reached")}
				subtitle={i18n("Try the following promotion, thanks!")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'no_prizes') {
		return (
			<Wrapper
				icon='knk-winners'
				title={i18n("All prizes have been given")}
				subtitle={i18n("Try the following promotion, thanks!")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'no_more_prizes') {
		return (
			<Wrapper
				icon='knk-drop redIcon'
				title={i18n("Sold-Out prizes")}
				subtitle={i18n("You can no longer participate because all prizes are sold out.")}
				error_type={error_type}
				link={{
					_href:`/p/${promotion.id}`,
					children:"Go back",
				}}
				link_type='link'
			/>
		)
	}

	if(error_type == 'unavailable_stage') {
		return (
			<Wrapper
				title={i18n("This participation stage is not published")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'roulette_no_prize') {
		return (
			<Wrapper
				icon='knk-winners'
				title={i18n("The wheel has no more prizes available")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'test_mode') {
		return (
			<Wrapper
				icon='knk-preview'
				title={i18n("Test Mode Activated")}
				subtitle={i18n("Only the administrators and agents linked to the promotion can access the test.")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'one_prize') {

		return (
			<Wrapper
				icon='knk-winners'
				title={i18n("You already won a prize")}
				subtitle={`${i18n("Check it out here")}:`}
				error_type={error_type}
				link={{
					_href:link_my_participations,
					children:label_my_participations,
				}}
				link_type='link'
			/>
		)
	}

	if(error_type == 'prize_limit') {
		return (
			<Wrapper
				icon='knk-winners'
				title={i18n("You can't win more prizes")}
				error_type={error_type}
				link={{
					_href:link_my_participations,
					children:label_my_participations,
				}}
				link_type='link'
			/>
		)
	}

	if(error_type == 'segment') {
		return (
			<Wrapper
				icon='knk-blocked'
				title={i18n("Restricted access")}
				subtitle={b64DecodeUnicode(props.custom_subtitle)}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'no_more_participations' && remaining_participations !== false) {
		let participate_message = i18n("You don't have more participations for this stage.");

		const participation_frequency = remaining_participations?.participation_frequency ?? false;
		if(participation_frequency !== false && remaining_participations?.remaining != undefined && remaining_participations?.remaining != "0") {
			if(remaining_participations.participation_frequency == 'week') {
				participate_message = i18n("You can participate in %s days");
			}

			if(remaining_participations.participation_frequency == 'day') {
				participate_message = i18n("You can participate in %s hours");
			}
			
			if(remaining_participations.participation_frequency == 'hour') {
				participate_message = i18n("You can participate in %s minutes");
			}

			participate_message = participate_message.replace("%s", (parseInt(remaining_participations.remaining) + 1));
		}

		return (
			<Wrapper
				icon='knk-blocked'
				title={i18n("No more participations")}
				subtitle={participate_message}
				error_type={error_type}
				link={{
					_href:link_my_participations,
					children:label_my_participations,
				}}
				link_type='link'
			/>
		)
	}

	if(error_type == 'no_more_participations' && remaining_participations === false) {
		return (
			<Wrapper
				icon='knk-blocked'
				title={i18n("No more participations")}
				subtitle={i18n("You don't have more participations for this stage.")}
				error_type={error_type}
				link={{
					_href:link_my_participations,
					children:label_my_participations,
				}}
				link_type='link'
			/>
		)
	}

	if(error_type == 'not_activated') {
		return (
			<Wrapper
				icon='knk-blocked'
				title={i18n("Promotion not activated")}
				error_type={error_type}
			/>
		)
	}

	if(error_type == 'pending') {
		return (
			<Wrapper
				icon='ep-time'
				subtitle={i18n("The promotion will be available in")}
				error_type={error_type}
				seconds={props?.seconds}
				onFinish={navigateToPromo}
			/>
		)
	}

	if(error_type == 'registration_pending') {
		return (
			<Wrapper
				icon='knk-timecounter'
				title={i18n("The promotion will open in")}
				error_type={error_type}
				seconds={props?.seconds}
				onFinish={navigateToPromo}
			/>
		)
	}

	if(error_type == 'completed') {
		return (
			<Wrapper
				icon='ep-ok greenIcon'
				title={i18n("Completed")}
				subtitle={i18n("You already completed this game.")}
				link={{
					_href:`/p/${promotion.id}`,
					children:"Go back",
				}}
				link_type='link'
			/>
		)
	}

	return (
		<Wrapper
			icon='knk-zipped'
			title={i18n("Not available")}
			error_type={error_type}
		/>
	)
};

export default injectIntl(NotAllowed);